import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  MobileListSectionComponent,
  TMobileListSectionItem,
} from '@prlw/common/mobile-list-section/mobile-list-section.component';
import { MobileOverlayCardComponent } from '@prlw/common/mobile-overlay-card/mobile-overlay-card.component';

@Component({
  selector: 'prlw-product-group-filter-mobile-ui',
  standalone: true,
  imports: [MobileOverlayCardComponent, MobileListSectionComponent],
  templateUrl: './product-group-filter-mobile.component.html',
  styleUrl: './product-group-filter-mobile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductGroupFilterMobileComponent {
  @Input() selectedItems: TMobileListSectionItem[] | null = [];
  @Input() otherItems: TMobileListSectionItem[] | null = [];

  @Output() eventClickX = new EventEmitter<void>();
  @Output() eventSelectProductGroup =
    new EventEmitter<TMobileListSectionItem>();
  @Output() eventProductGroupSelected =
    new EventEmitter<TMobileListSectionItem>();
  @Output() eventProductGroupUnselected =
    new EventEmitter<TMobileListSectionItem>();
}
